module.exports = __webpack_public_path__ + "img/img8.7e6fe26a.png";